module.exports = __webpack_public_path__ + "img/7.9bd58584.jpg";